import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  onEditClick(e) {
    e.preventDefault()
    const customerId = e.currentTarget.dataset.customerId
    window.location = `/admin/customers/${customerId}`
  }

}